import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Inject, Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { Observable, of } from "rxjs";
import { concatMap } from "rxjs/operators";
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from "@azure/msal-angular";
import { BaseGuard } from "../../base.guard";

@Injectable()
export class RoleGuard extends BaseGuard {
  constructor(
    @Inject(MSAL_GUARD_CONFIG) protected override msalGuardConfig: MsalGuardConfiguration,
    protected override msalBroadcastService: MsalBroadcastService,
    protected override authService: MsalService,
    protected override location: Location,
    protected override router: Router
  ) 
  {
    super(msalGuardConfig, msalBroadcastService, authService, location, router);
  }

  override activateHelper(state?: RouterStateSnapshot, route?: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const result = super.activateHelper(state, route);

    // const expectedRoles: string[] = route ? route.data['expectedRoles'] : [];
    
    const expectedRoles: ReadonlyArray<string> =
      (route && route.data && route.data['roles']) || [];


    return result.pipe(
      concatMap((isAuthenticated) => {
        
        
        // If MSAL denied access, respect it
        if (isAuthenticated === false) {
          return of(false);
        }
        // No role required → allow
        if (!expectedRoles.length) {
          return of(true);
        }

        let activeAccount = this.authService.instance.getActiveAccount();

        if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
            activeAccount = this.authService.instance.getAllAccounts()[0];
        }

        const userRoles = activeAccount?.idTokenClaims?.roles as string[] | undefined;
        
        if (!userRoles) {
          // ✅ HARD redirect to 403
          return of(this.router.parseUrl('/403'));
        }

        if (!activeAccount?.idTokenClaims?.roles) {
          //window.alert('Token does not have roles claim. Please ensure that your account is assigned to an app role and then sign-out and sign-in again.');
          return of(this.router.parseUrl('/403'));
        }

        const hasRequiredRole = expectedRoles.some((role: string) => activeAccount?.idTokenClaims?.roles?.includes(role));
        if (!hasRequiredRole) {
          return of(this.router.parseUrl('/403'));
            //window.alert('You do not have access as the expected role is not found. Please ensure that your account is assigned to an app role and then sign-out and sign-in again.');
        }

        return of(true);
      })
    );
  }
}
  
